var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.64V18.72C20 17.7016 19.5786 16.7249 18.8284 16.0047C18.0783 15.2846 17.0609 14.88 16 14.88H8C6.93913 14.88 5.92172 15.2846 5.17157 16.0047C4.42143 16.7249 4 17.7016 4 18.72V20.64",
    stroke: "#22374A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.04C14.2091 11.04 16 9.32076 16 7.19999C16 5.07921 14.2091 3.35999 12 3.35999C9.79086 3.35999 8 5.07921 8 7.19999C8 9.32076 9.79086 11.04 12 11.04Z",
    stroke: "#22374A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.e5cc60cc2668e5b5206ba5648d0b326e.svg";
export { ForwardRef as ReactComponent };